module.exports = __webpack_public_path__ + "6dbd757cb221cbdefe10f6baa002885f.pdf";